import { useMemo } from 'react';

import { useGetDescriptionOfRiskLovs } from '../proposal.slice';

type RiskLovs = {
  geoLocations: Record<string, string>;
};

export function useDescriptionOfRiskLovs(isRisk: boolean): RiskLovs {
  const { data } = useGetDescriptionOfRiskLovs({ skip: !isRisk });

  const riskLovs: RiskLovs = useMemo(() => {
    const geoLocations = (data?.production?.getGeoLocations ?? []).reduce(
      (acc: Record<string, string>, g: any) => {
        acc[String(g.id)] = String(g.title ?? g.code ?? g.id);

        return acc;
      },
      {}
    );

    return { geoLocations };
  }, [data]);

  return riskLovs;
}
